(function () {
  const configElement = document.getElementById('sajada-free-gift-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const GIFT_VARIANT_ID = config.beadsVariantId;
  const DUAA_VARIANT_ID = config.duaaVariantId;
  const TOTEBAG_VARIANT_ID = config.totebagVariantId;
  const ENABLE_FREE_GIFTS_4_5 = config.enableThresholdGifts;
  const PSG_PAIRS = config.productGifts;

  // All gift variant IDs across both systems — used to skip free items
  const ALL_GIFT_VARIANT_IDS = new Set(
    [GIFT_VARIANT_ID, DUAA_VARIANT_ID, TOTEBAG_VARIANT_ID,
     ...PSG_PAIRS.filter(function(p){ return p.enabled; }).map(function(p){ return p.giftVariantId; })]
    .filter(Boolean)
  );

  // ─── Sync state ───────────────────────────────────────────────────────
  let syncing     = false;
  let pendingSync = false;
  let _isSyncFetch = false;   // flag so the monkey-patch skips our own calls

  // ─── Checkout lock ────────────────────────────────────────────────────
  function getCheckoutEls() {
    return Array.from(document.querySelectorAll(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"],' +
      '[data-cart-checkout], .cart__checkout, #CartDrawer-Checkout,' +
      '.cart-drawer__checkout, [href="/checkout"]'
    ));
  }

  function lockCheckout() {
    getCheckoutEls().forEach(function (el) {
      // Repeated cart events must retain the real checkout destination.
      if (el.hasAttribute('data-gift-sync-locked')) return;
      el.setAttribute('data-gift-sync-locked', 'true');
      el.setAttribute('aria-busy', 'true');
      if (el.tagName === 'A') {
        el.dataset.giftSyncHref = el.href;
        el.href = 'javascript:void(0)';
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.6';
      } else {
        el.disabled = true;
        el.style.opacity = '0.6';
      }
    });
  }

  function unlockCheckout() {
    document.querySelectorAll('[data-gift-sync-locked="true"]').forEach(function (el) {
      el.removeAttribute('data-gift-sync-locked');
      el.removeAttribute('aria-busy');
      if (el.tagName === 'A') {
        if (el.dataset.giftSyncHref) {
          el.href = el.dataset.giftSyncHref;
          delete el.dataset.giftSyncHref;
        }
        el.style.pointerEvents = '';
        el.style.opacity = '';
      } else {
        el.disabled = false;
        el.style.opacity = '';
      }
    });
  }

  var checkoutUnlockSafetyTimer = null;
  function setCheckoutLock(locked) {
    clearTimeout(checkoutUnlockSafetyTimer);
    if (locked) {
      lockCheckout();
      checkoutUnlockSafetyTimer = setTimeout(unlockCheckout, 10000);
    } else {
      unlockCheckout();
    }
  }

  // ─── Internal fetch ───────────────────────────────────────────────────
  // Uses the LIVE window.fetch (so any third-party wrappers still run)
  // but sets _isSyncFetch = true so our monkey-patch knows to skip it.
  var _originalFetch = window.fetch;
  function internalFetch() {
    _isSyncFetch = true;
    var p = _originalFetch.apply(window, arguments);
    // Reset flag on the NEXT microtask (after monkey-patch has checked it)
    p.then(function(){ _isSyncFetch = false; }, function(){ _isSyncFetch = false; });
    return p;
  }

  // ─── Core sync logic (shared by fast + deferred passes) ───────────────
  async function runSync() {
    // ① Fetch cart + eligibility section IN PARALLEL (fast)
    var results = await Promise.all([
      internalFetch('/cart.js').then(function(r){ return r.json(); }),
      internalFetch('/?section_id=cart-gift-eligibility').then(function(r){ return r.text(); })
    ]);
    var cart            = results[0];
    var eligibilityHtml = results[1];

    // ② Parse eligibility JSON
    var parser = new DOMParser();
    var doc    = parser.parseFromString(eligibilityHtml, 'text/html');
    var dataEl = doc.getElementById('cart-gift-eligibility-data');
    var eligibilityData = { eligibleCount: 0, items: [] };
    if (dataEl) {
      try { eligibilityData = JSON.parse(dataEl.textContent); } catch(e) {}
    }
    var eligibleCount = eligibilityData.eligibleCount || 0;
    var sectionStale  = (eligibilityData.items.length !== cart.items.length);

    // ③ Compute required beads qty
    var requiredBeadsQty = 0;

    cart.items.forEach(function(item) {
      var isFreeByProp    = item.properties && item.properties['_Free Gift'];
      var isFreeByVariant = ALL_GIFT_VARIANT_IDS.has(item.variant_id);
      if (isFreeByProp || isFreeByVariant) return;

      var giftQty = Number((item.properties && item.properties._gift_qty) || 0);
      var serverItem = eligibilityData.items.find(function(i){ return i.key === item.key; });
      if (serverItem && serverItem.eligible) {
        giftQty = Math.max(giftQty, 1);
      }
      requiredBeadsQty += giftQty * item.quantity;
    });

    var requiredDuaaQty    = (ENABLE_FREE_GIFTS_4_5 && eligibleCount >= 4) ? 1 : 0;
    var requiredTotebagQty = (ENABLE_FREE_GIFTS_4_5 && eligibleCount >= 5) ? 1 : 0;

    // ④ Product-specific gifts
    var psgRequired = PSG_PAIRS.map(function(pair) {
      if (!pair.enabled) return 0;
      var triggerQty = 0;
      cart.items.forEach(function(item) {
        var isFreeByProp    = item.properties && item.properties['_Free Gift'];
        var isFreeByVariant = ALL_GIFT_VARIANT_IDS.has(item.variant_id);
        if (isFreeByProp || isFreeByVariant) return;
        if (item.product_id == pair.triggerProductId) {
          triggerQty += item.quantity;
        }
      });
      return triggerQty;
    });

    // ⑤ Build add / update lists
    var hasChanged = false;
    var itemsToAdd = [];
    var updates    = {};

    // Each free-gift variant must live on exactly ONE cart line at the required qty.
    // Any extra line of the same variant (e.g. added from the gift's own product page
    // without the '_Free Gift' property) is set to 0 so customers can't top up gifts.
    function reconcileGift(variantId, requiredQty, label) {
      if (!variantId) return;
      var lines = cart.items.filter(function(i){ return i.variant_id == variantId; });
      var keeper = lines.find(function(i){ return i.properties && i.properties['_Free Gift']; }) || null;
      lines.forEach(function(line) {
        if (line !== keeper) updates[line.key] = 0;
      });
      if (keeper) {
        if (keeper.quantity !== requiredQty) updates[keeper.key] = requiredQty;
      } else if (requiredQty > 0) {
        itemsToAdd.push({ id: variantId, quantity: requiredQty, properties: { '_Free Gift': label } });
      }
    }

    reconcileGift(GIFT_VARIANT_ID, requiredBeadsQty, 'Prayer Beads');
    reconcileGift(DUAA_VARIANT_ID, requiredDuaaQty, 'Duaa Stickers');
    reconcileGift(TOTEBAG_VARIANT_ID, requiredTotebagQty, 'Totebag');

    PSG_PAIRS.forEach(function(pair, idx) {
      if (!pair.enabled) return;
      reconcileGift(pair.giftVariantId, psgRequired[idx], pair.giftLabel);
    });

    // ⑥ Write back
    if (itemsToAdd.length > 0) {
      await internalFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
      hasChanged = true;
    }

    if (Object.keys(updates).length > 0) {
      await internalFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      hasChanged = true;
    }

    return { hasChanged: hasChanged, sectionStale: sectionStale };
  }

  // ─── Main sync wrapper ────────────────────────────────────────────────
  async function syncFreeGifts() {

    if (syncing) {
      pendingSync = true;
      return;
    }

    syncing = true;
    pendingSync = false;
    setCheckoutLock(true);

    try {

      var result = await runSync();

      // Confirm pass: re-check shortly after any change so a write that was
      // overwritten by another app's cart update gets repaired.
      if (result.hasChanged) {
        window._giftConfirmCount = (window._giftConfirmCount || 0) + 1;
        if (window._giftConfirmCount <= 4) {
          clearTimeout(window._giftConfirmTimer);
          window._giftConfirmTimer = setTimeout(function(){ scheduleSyncFreeGifts(0); }, 1200);
        }
      } else {
        window._giftConfirmCount = 0;
      }

      if (result.hasChanged) {
        document.dispatchEvent(new CustomEvent('theme-cart:updated', {
          detail: { shouldOpenCart: false, fromSync: true }
        }));
      }

      // ── Deferred correction pass ──────────────────────────────────────
      // If the eligibility section was stale (Shopify hadn't caught up),
      // re-run once more after a short wait so the section is consistent.
      // This catches any gifts missed on the very first add-to-cart.
      if (result.sectionStale) {
        clearTimeout(window._giftDeferredTimer);
        window._giftDeferredTimer = setTimeout(async function() {
          syncing = true;
          setCheckoutLock(true);
          try {
            var r2 = await runSync();
            if (r2.hasChanged) {
              document.dispatchEvent(new CustomEvent('theme-cart:updated', {
                detail: { shouldOpenCart: false, fromSync: true }
              }));
            }
          } catch(e) {
            console.error('Free gift deferred sync error:', e);
          } finally {
            syncing = false;
            setCheckoutLock(false);
          }
        }, 500);
      }

    } catch (error) {
      console.error('Free gift sync error:', error);
    } finally {
      syncing = false;
      setCheckoutLock(false);
      if (pendingSync) {
        pendingSync = false;
        syncFreeGifts();
      }
    }
  }

  // ─── Schedule helper ──────────────────────────────────────────────────
  function scheduleSyncFreeGifts(delayMs) {
    clearTimeout(window.freeGiftSyncTimer);
    window.freeGiftSyncTimer = setTimeout(syncFreeGifts, delayMs != null ? delayMs : 0);
  }

  // ─── Monkey-patch window.fetch ────────────────────────────────────────
  window.fetch = async function () {
    // If this call came from internalFetch, skip the sync trigger
    if (_isSyncFetch) {
      return _originalFetch.apply(this, arguments);
    }

    var response = await _originalFetch.apply(this, arguments);
    try {
      var url = typeof arguments[0] === 'string' ? arguments[0]
              : (arguments[0] && arguments[0].url) || '';
      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update')
      ) {
        setCheckoutLock(true);
        scheduleSyncFreeGifts(0);    // run on next tick — zero delay
      }
    } catch (e) {
      console.error('Free gift sync: fetch intercept error', e);
    }
    return response;
  };

  // ─── Form submit fallback ─────────────────────────────────────────────
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    setCheckoutLock(true);
    scheduleSyncFreeGifts(100);
  });

  // ─── Cart events ──────────────────────────────────────────────────────
  document.addEventListener('theme-cart:updated', function(e) {
    if (e.detail && e.detail.fromSync) return;
    scheduleSyncFreeGifts(0);
  });

  // ─── Initial sync on page load ────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scheduleSyncFreeGifts(50);
    });
  } else {
    scheduleSyncFreeGifts(50);
  }

        })();
